export const LOAD_TABLE_DATA = "LOAD_TABLE_DATA";
